module.exports = __webpack_public_path__ + "img/family-cows.0923322d.jpg";